import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE } from "../../../constants/global";
import { Toaster } from "../../../entity/GlobalJS";

const CircleMeetingsCreate = (props) => {
    const navigate = useNavigate();
    const { unique_id } = useParams();
    const userData = JSON.parse(localStorage.getItem('lmsuser'));
    const [list_timezones, setListTimezones] = useState('');
    const [min_time, setMinTime] = useState('');
    const [api_errors, setApiErrors] = useState([]);
    const [form_success, setFormSuccess] = useState('');

    const [time_zone_time, setTimeZoneTime] = useState('');

    useEffect(() => {
        fetchTimezones();
        // eslint-disable-next-line 
    }, []);

    const [submitting, setSubmitting] = useState(false);
    const _token = localStorage.getItem('lmstoken');
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    const saveMeeting = async (form) => {
        setSubmitting(true);
        const response = await fetch(`${API_BASE}create-group-meeting/${unique_id}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
            body: JSON.stringify(form)
        });

        const data = await response.json();
        if (data.status) {
            setApiErrors([]);
            setFormSuccess(data.message);
            setTimeout(() => {
                setFormSuccess('');
                navigate(`/view-learning-circle/${unique_id}/meetings`);
            }, 5000);
            window.scrollTo(0, 500);
        } else {
            setApiErrors(data.message);
        }

        setSubmitting(false);
    }

    const fetchTimezones = async () => {
        const response = await fetch(`${API_BASE}get-all-timezones`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            setListTimezones(data.data.timezones);
        } else {
            setListTimezones('');
        }
    }

    const getDateTime = () => {
        let timeZone = document.getElementById('timeZone').value;
        let obj = list_timezones.find(o => o.time_zone === timeZone);
        let selectedOffset = Number(obj.time_zone_offset.replace('GMT', '').replace(':', '.'));
        let myTimeOffset = Number((new Date().getTimezoneOffset() / 60));
        let differ = myTimeOffset + selectedOffset;
        let currentTime = new Date().getTime();
        let updatedTIme = new Date(currentTime + differ * 60 * 60 * 1000);

        let date = document.getElementById('date_field').value;
        if (typeof date !== 'undefined' && date === new Date().toISOString().split('T')[0]) {
            setMinTime(updatedTIme.getHours() + ':' + updatedTIme.getMinutes());
        }
        setTimeZoneTime(updatedTIme.getHours() + ':' + updatedTIme.getMinutes());
        setValue('time_zone_time', updatedTIme.getHours() + ':' + updatedTIme.getMinutes());
    }

    const setTime = (date) => {
        if (date === new Date().toISOString().split('T')[0]) {
            setMinTime(time_zone_time);
        }
        else {
            setMinTime('');
        }
    }

    return (
        <>
            <section className={`custom-section member_section`}>
                <div className="profile_user_middle_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="custom-user-profile-content custom-learning-circle-content">
                                    <div className="custom-learnig-circle-head">
                                        <h4>Add Meeting</h4>
                                    </div>
                                    <div className="learning-circle-form">
                                        {form_success ? <div className="row"><div className="col-12 mb-0 mt-0"><span className="text-success">{form_success}</span></div></div> : null}
                                        <form onSubmit={handleSubmit(saveMeeting)}>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <select {...register("timezone")} id="timeZone" onChange={(e) => { getDateTime(); }} className="form-control" autoFocus>
                                                            <option value="">Select Timezone</option>
                                                            {
                                                                list_timezones !== ''
                                                                &&
                                                                list_timezones.map((timezone, index) =>
                                                                    <option key={index} value={timezone.time_zone}>{timezone.locations}  ({timezone.time_zone_offset})</option>
                                                                )
                                                            }
                                                        </select>
                                                        <span className="text-danger">
                                                            {errors.timezone && errors.timezone.type === "required" && 'Please select timezone.'}
                                                            {errors.timezone && errors.timezone.type !== "required" && errors.timezone.message}
                                                        </span>
                                                        {
                                                            api_errors?.timezone
                                                                ?
                                                                <span className="text-danger">
                                                                    {api_errors?.timezone.join(' ')}
                                                                </span>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input id="title" {...register("title", {
                                                            required: "required",
                                                            maxLength: {
                                                                value: 80,
                                                                message: "Title can not be more than 80 charaters."
                                                            }
                                                        })} type="text" className="form-control" placeholder="Meeting Topic*" />
                                                        <span className="add-on max-chr-counter chrchk-title" data-ele="title" data-limit="80" data-showcounter="true"></span>
                                                        <span className="text-danger">
                                                            {errors.title && errors.title.type === "required" && 'Please enter meeting topic.'}
                                                            {errors.title && errors.title.type !== "required" && errors.title.message}
                                                        </span>
                                                        {
                                                            api_errors?.title
                                                                ?
                                                                <span className="text-danger">
                                                                    {api_errors?.title.join(' ')}
                                                                </span>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <textarea {...register("agenda", { required: "required", })} className="form-control" placeholder="Short Agenda*" rows="5"></textarea>
                                                        <span className="text-danger">
                                                            {errors.agenda && errors.agenda.type === "required" && 'Please enter meeting agenda.'}
                                                            {errors.agenda && errors.agenda.type !== "required" && errors.agenda.message}
                                                        </span>
                                                        {
                                                            api_errors?.agenda
                                                                ?
                                                                <span className="text-danger">
                                                                    {api_errors?.agenda.join(' ')}
                                                                </span>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input {...register("date", { required: "required" })} id="date_field" type="date" min={new Date().toISOString().split('T')[0]} className="form-control" placeholder="Date*" onChange={(e) => { setTime(e.target.value) }} />
                                                        <span className="text-danger">
                                                            {errors.date && errors.date.type === "required" && 'Please select meeting date.'}
                                                            {errors.date && errors.date.type !== "required" && errors.date.message}
                                                        </span>
                                                        {
                                                            api_errors?.date
                                                                ?
                                                                <span className="text-danger">
                                                                    {api_errors?.date.join(' ')}
                                                                </span>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input
                                                            {...register("time", { required: "required" })}
                                                            type="time"
                                                            min={min_time}
                                                            className="form-control"
                                                            placeholder="Time*"
                                                        />
                                                        <span className="text-danger">
                                                            {errors.time && errors.time.type === "required" && 'Please select meeting time.'}
                                                            {errors.time && errors.time.type !== "required" && errors.time.message}
                                                        </span>
                                                        {
                                                            api_errors?.time
                                                                ?
                                                                <span className="text-danger">
                                                                    {api_errors?.time.join(' ')}
                                                                </span>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <input {...register("duration", {
                                                            required: "required",
                                                            min: {
                                                                value: 10,
                                                                message: "Duration must be at least 10 minutes."
                                                            },
                                                            max: {
                                                                value: 200,
                                                                message: "Duration can not be more than 200 minutes."
                                                            }
                                                        })} type="number" className="form-control" placeholder="Duration(Minutes)*" />
                                                        <span className="text-danger">
                                                            {errors.duration && errors.duration.type === "required" && 'Please enter meeting duration in minutes.'}
                                                            {errors.duration && errors.duration.type !== "required" && errors.duration.message}
                                                        </span>
                                                        {
                                                            api_errors?.duration
                                                                ?
                                                                <span className="text-danger">
                                                                    {api_errors?.duration.join(' ')}
                                                                </span>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {api_errors?.other_error ? <div className="row"><div className="col-12 mb-0 mt-0"><span className="text-danger">{api_errors?.other_error}</span></div></div> : null}
                                            <a onClick={(e) => { navigate(`/view-learning-circle/${unique_id}/meetings`); }} className="btn btn-circle btn-md cancel-btn">Cancel</a>
                                            <button disabled={submitting} type="submit" className="btn btn-circle btn-md submit-pink-btn">{submitting ? <i className="fa fa-refresh fa-spin fa-fw"></i> : 'Submit'}</button>
                                        </form>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default CircleMeetingsCreate;